import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    Stack,
    Button,
    Heading,
    useColorModeValue,
} from '@chakra-ui/react'
import { useUserContext } from '../utils/userContext';
import {useEffect, useState} from 'react';
import { getAxiosInstance } from '../utils/axiosInstance';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const nav = useNavigate();

    const { setUser } = useUserContext();

    const { t } = useTranslation("translations");

    const submit = async () => {
        if (email !== "" && password !== "") {
            try {
                const res = await getAxiosInstance().post('/Account/login', { email, password });

                setUser({
                    username: res.data.username,
                    token: res.data.token,
                    isAuthenictated: true,
                    roles: res.data.roles,
                    isDefaultPassword: res.data.isDefaultPassword
                });

                // Save the token in the local storage
                localStorage.setItem("token", res.data.token);
                getAxiosInstance(true); // After lo gin force the reaction of the singleton
                nav("/dashboard");
                toast.success(t("LOGIN_SUCCESSFULLY"), { position: toast.POSITION.BOTTOM_RIGHT });
            } catch (error) {
                toast.error(t("USER_OR_PASSWORD_WRONG"), { position: toast.POSITION.BOTTOM_RIGHT });
            }
        }
    }

    useEffect(() => {
        if(process.env.REACT_APP_DEBUG === "true") {
            setEmail("admin@rpgsuceava.ro");
            setPassword("Pa$$w0rd");
        }
    }, [])

    return (
        <Flex
            minH={'100vh'}
            align={'center'}
            justify={'center'}
            bg={useColorModeValue('gray.50', 'gray.800')}>
            <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
                <div className='overflow-hidden h-[150px] md:h-[200px]'>
                    <img src="wearhouse.svg" className='top-50 left-0'></img>
                </div>
                <Stack align={'center'}>
                    <Heading fontSize={'4xl'}>{t("Sign in to your account")}</Heading>
                </Stack>
                <Box
                    rounded={'lg'}
                    bg={useColorModeValue('white', 'gray.700')}
                    boxShadow={'lg'}
                    p={8}>
                    <Stack spacing={4}>
                        <FormControl id="email">
                            <FormLabel>{t("EMAIL")}</FormLabel>
                            <Input placeholder={t("EMAIL")} value={email} onChange={(e) => { setEmail(e.target.value) }} type="email" />
                        </FormControl>
                        <FormControl id="password">
                            <FormLabel>{t("PASSWORD")}</FormLabel>
                            <Input placeholder={t("PASSWORD")} value={password} onChange={(e) => { setPassword(e.target.value) }} type="password" />
                        </FormControl>
                        <Stack spacing={10}>
                            <Button
                                bg={'blue.400'}
                                color={'white'}
                                _hover={{
                                    bg: 'blue.500',
                                }}
                                onClick={(e) => { submit() }}
                            >
                                {t("SIGN_IN")}
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            </Stack>
        </Flex>

    )
}

export default Login;
